export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-android-3.2355779a.svg";